module.exports = __webpack_public_path__ + "static/media/ottawa-45.33719ccf.jpg";